import { UMCRecordAudioController as controller } from './umc-record-audio.controller';
import { UMCRecordComponent } from '../umc-record.component';

export const UMCRecordAudioComponent = {
	...UMCRecordComponent,
	controller
};
